
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

import { shapes } from './memory-game.const';
import cover from '_images/yellow/cover.png';

export default class MemoryGameController {
    constructor($log, $state, $timeout) {
        'ngInject';
        this.$log = $log;
        this.$state = $state;
        this.$timeout = $timeout;
        this.cover = cover;
        this.openedCards = [];
        this.matchedCards = [];
    }

    $onInit(){
        this.title="<span class='level'> Pensamento - Nível "+this.level+"</span> <br/> Encontre os pares correspondentes";
        switch(this.level){
            case 1:
            this.cards = this.shuffleCards(shapes, 8);
            break;
            case 2:
            this.cards = this.shuffleCards(shapes, 12);
            break;
            default:
            case 3:
            this.cards = this.shuffleCards(shapes, 16);
        }
    }

    openCard(i){
        if(!this.cards[i].isDisabled){
            this.cards[i].class = 'flip';
            // this.$timeout(() => this.cards[i].cover = false, 250);
            this.openedCards.push(this.cards[i]);
            if(this.openedCards.length === 2){
                if(this.openedCards[0].id === this.openedCards[1].id && this.openedCards[0].type !== this.openedCards[1].type)
                    this.matched();
                else
                    this.unmatched();
            }
        }
    }

    matched(){
        this.matchedCards = _.concat(this.matchedCards, this.openedCards);
        this.openedCards[0].cover = false;
        this.openedCards[1].cover = false;
        this.openedCards[0].class += ' matched';
        this.openedCards[1].class += ' matched';
        this.openedCards = [];
        this.enable();
        if(this.matchedCards.length === this.cards.length){
            this.endGame();
        }
    }

    unmatched(){
        let $ctrl = this;
        this.disable();
        this.$timeout(function() {
            $ctrl.openedCards[0].cover = true;
            $ctrl.openedCards[1].cover = true;
            $ctrl.openedCards[0].class = '';
            $ctrl.openedCards[1].class = '';
            $ctrl.enable();
            $ctrl.openedCards = [];
        }, 1800);
    }

    disable(){
        let i = 0;
        for( i = 0; i<this.cards.length ; i++)
            this.cards[i].isDisabled = true;
    }

    enable(){
        let i = 0;
        for( i = 0; i<this.cards.length ; i++){
            if(!this.cards[i].cover)
                this.cards[i].isDisabled = true;
            else
                this.cards[i].isDisabled = false;
        }
    }

    cardCover(c){
        let coverCard = this.cover;
        if(c.cover){
            return coverCard;
        } else {
            return c.src;
        }
    }

    /**
    /* total => array com a quantidade de cartas para cada forma abstrata
    /* pickMatch => Quantidade de objetos reais de acordo com o num que está em total[ii]
    /* pickCard => Forma abstrata
    /* src => local da imagem
    /* cover => Se está com a face virada para baixo
    /* id => Qual forma representa
    /* type => se a forma é concreta ou abstrata
    /* isDisabled => se ainda pode ser clicado ou não
    */

    shuffleCards(o, max){
        let arr = [];
        let cards = [];
        let ii = 0;
        max = max/2;
        if(max>o.length){
            let extraObj = max - o.length;
            arr = _.concat(o,_.sampleSize(o,extraObj));
            let total = _.values(_.countBy(arr,'name'));

            for (ii = 0; ii < total.length; ii++){
                let pickMatch = _.sampleSize(arr[ii].realObjects,total[ii]);
                for(let j = 0; j < total[ii]; j++){
                    let pickCard = arr[ii].abstract;
                    cards.push({src: pickCard, cover: true, id: arr[ii].name, type: 'abstract', isDisabled: false, class: ''});
                    cards.push({src: pickMatch[j], cover: true, id: arr[ii].name, type: 'concrete', isDisabled: false, class: ''})
                }
            }
        } else {
            arr = _.sampleSize(o,max);
            for(ii = 0; ii < max; ii++){
                let pickCard = arr[ii].abstract;
                let pickMatch = _.sample(arr[ii].realObjects);
                cards.push({src: pickCard, cover: true, id: arr[ii].name, type: 'abstract', isDisabled: false, class: ''});
                cards.push({src: pickMatch, cover: true, id: arr[ii].name, type: 'concrete', isDisabled: false, class: ''});
            }
        }
        return _.shuffle(cards);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/memory-game/memory-game.controller.js